import { W as WuiSelectInput$1, d as defineCustomElement$1 } from './p-DhAaK1Y5.js';

const WuiSelectInput = WuiSelectInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiSelectInput, defineCustomElement };
